import '.';

const uppy = window.uppyInstance;

const showFileResponse = (cardId, uploadDone, type) => {
  uppy.setOptions({ restrictions: { allowedFileTypes: null } });
  uppy.getPlugin('Dashboard').setOptions({ plugins: [], disableLocalFiles: type === 'record' });
  uppy.getPlugin('Dashboard').openModal();

  uppy.once('complete', result => {
    uploadDone &&
      uploadDone({
        url: result.successful[0].uploadURL,
        filename: result.successful[0].name,
        size: result.successful[0].size
      });
    uppy.removeFile(result.successful[0].id);

    try {
      window.analytics.track('UPPY_FILE_UPLOAD_FINISHED', {
        cardId,
        fileUrl: result.successful[0].uploadURL
      });
    } catch (e) {
      console.error(e);
    }
  });

  uppy.once('upload-error', (file, error) => {
    window.bugsnagClient && window.bugsnagClient.notify(error);
    window.analytics.track('UPPY_FILE_UPLOAD_FAILED', {
      cardId,
      error
    });
  });
};

export default showFileResponse;
